import { Card, Text, Title } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { ExtendedCoverage } from '@seen/core/models/coverage'
import { Button } from '@seen/ui'
import type { JSX } from 'react'
import { useParams } from 'react-router'
import { CoverageDialog } from '#src/components/coverage/CoverageDialog.tsx'
import { DataDisplay } from '#src/components/display/DataDisplay.tsx'
import { DateDisplay } from '#src/components/display/DateTimeDisplay.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export function CoverageDisplayPage(): JSX.Element {
  const { coverageId } = useParams()
  const [showEditModal, { open: openEditModal, close: closeEditModal }] =
    useDisclosure(false)

  const { data: coverage, isLoading } = useRead(ExtendedCoverage, coverageId)
  if (isLoading) {
    return <div>Loading...</div>
  }

  if (!coverage) {
    return <div>Coverage not found</div>
  }

  return (
    <>
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Title order={2}>Coverage Details</Title>
          <div className="flex justify-end">
            <Button variant="outline" onClick={openEditModal}>
              Edit Coverage
            </Button>
          </div>
        </div>
        <Card withBorder>
          <Title order={3}>Overview</Title>
          <div className="space-y-4 mt-2">
            <DataDisplay
              label="Type"
              value={<Text>{coverage.typeDisplay}</Text>}
            />
            <DataDisplay
              label="Member ID"
              value={coverage.subscriberId}
              placeholder="Not on file"
            />
            <DataDisplay
              label="Start Date"
              value={<DateDisplay value={coverage.startDate} />}
            />
            <DataDisplay
              label="End Date"
              value={<DateDisplay value={coverage.endDate} />}
            />
          </div>
        </Card>
      </div>

      <CoverageDialog
        coverage={coverage}
        open={showEditModal}
        onOpenChange={(open) => {
          if (!open) {
            closeEditModal()
          }
        }}
      />
    </>
  )
}
